<template>
  <div>
    <el-row :gutter="20">
      <el-col :span="12">
        <el-card
          class="card"
          shadow="hover"
          style="border-color: #ededed;"
          @click.native="jumpAddContact()"
        >
          <div class="side-frame">
            <h3>{{ $l('INDEX.tips_Scan_businessCard') || '扫描名片' }}</h3>
          </div>
        </el-card>
      </el-col>

      <el-col :span="12">
        <el-card
          class="card"
          shadow="hover"
          style="border-color: #ededed;"
          @click.native="jumpScmInfoTemp()"
        >
          <div class="side-frame">
            <h3>{{ $l('INDEX.tips_manual_input') || '手动输入' }}</h3>
          </div>
        </el-card>
      </el-col>
    </el-row>
  </div>
</template>

<script>
export default {
  methods: {
    jumpAddContact() {
      this.$emit('closeDialog')
      this.$emit('openEditContact')
    },
    jumpScmInfoTemp() {
      let params = {
        pageType: 'add',
      }
      this.$emit('closeDialog')
      this.$router.push({
        name: 'resourceManagement-scmInfoTemp',
        params: params,
      })
    },
  },
}
</script>
<style scoped>
h2 {
  text-align: center;
  display: inline;
}
</style>
